"use client"

import { X, Gift, Sparkles } from "lucide-react"

interface PromoBannerProps {
  onClose: () => void
  onLogin: () => void
}

export function PromoBanner({ onClose, onLogin }: PromoBannerProps) {
  return (
    <div className="fixed left-0 right-0 top-14 z-[49] border-b border-emerald-500/10 bg-[oklch(0.97_0.035_155/0.92)] text-emerald-950 shadow-sm backdrop-blur-xl dark:bg-[oklch(0.20_0.045_160/0.92)] dark:text-emerald-50">
      <div className="mx-auto flex min-h-10 max-w-6xl items-center justify-between gap-3 px-4 py-2 sm:px-6">
        <div className="flex min-w-0 items-center gap-2">
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-500 text-white shadow-sm shadow-emerald-500/20">
            <Gift className="h-3.5 w-3.5" />
          </span>
          <p className="truncate text-xs font-medium sm:text-sm">
            手机号登录即送体验金，立即解锁 SafeClaw 创作额度
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-1">
          <button
            type="button"
            onClick={onLogin}
            className="inline-flex h-7 items-center gap-1 rounded-full bg-foreground px-3 text-xs font-semibold text-background transition-colors hover:bg-foreground/90"
          >
            <Sparkles className="h-3 w-3" />
            登录领取
          </button>
          <button
            type="button"
            aria-label="关闭登录优惠横幅"
            onClick={onClose}
            className="flex h-7 w-7 items-center justify-center rounded-full text-emerald-950/60 transition-colors hover:bg-emerald-950/10 hover:text-emerald-950 dark:text-emerald-50/70 dark:hover:bg-white/10 dark:hover:text-emerald-50"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </div>
  )
}
